export default "__VITE_ASSET__BzU6rAsm__"